/* eslint-disable import/prefer-default-export */
import { useQuery } from '@tanstack/react-query';

import {
  type KpiSummaryResponse,
  KpiSummaryService,
} from '../services/KpiSummaryService';

/**
 * Hook to fetch KPI summary data for dashboard tiles
 * Uses React Query for caching and automatic refetching
 * @returns React Query result with KPI summary data
 */
export const useKpiSummary = () =>
  useQuery<KpiSummaryResponse>({
    queryKey: ['kpiSummary'],
    queryFn: () => KpiSummaryService.getKpiSummary(),
    // cache the data for 5 minutes since KPI data doesn't change frequently
    staleTime: 5 * 60 * 1000,
    retry: 1,
    refetchOnWindowFocus: false,
  });
